import { defaultTaskFormValues, fieldTypes, priorityCodes, SERVER_DATE_FORMAT } from "../constants";
import { translate } from "@td/shared_utils";
import moment from "moment-timezone";

export const mapValuesToFormData = (values) => {
  return {
    taskTypeCd: values[fieldTypes.TASK_TYPE].value,
    taskNm: values[fieldTypes.TASK_TYPE].value === "TASKTYPE_OTHER"
      ? values[fieldTypes.TASK_NAME]
      : null,
    taskCategoryCd: values[fieldTypes.CATEGORY].value,
    taskStatusCd: values[fieldTypes.STATUS].value,
    taskPriorityCd: values[fieldTypes.URGENT] ? priorityCodes.URGENT : priorityCodes.MEDIUM,
    dueDt: moment(values[fieldTypes.DUE_DATE]).tz(window.APP_TIMEZONE, true).endOf("day").toISOString(),
    taskDesc: values[fieldTypes.CHECKLIST].map(({ text, completed }) => ({ text, completed })),

    ...(!!values[fieldTypes.NOTES] && ({
      note: values[fieldTypes.NOTES],
    })),

    ...(values[fieldTypes.ASSIGNEE] && values[fieldTypes.ASSIGNEE].value ? ({
      ownerId: parseInt(values[fieldTypes.ASSIGNEE].value),
      ownerType: "Admin",
    }) : ({
      ownerId: "",
      ownerType: "Admin",
    })),

    ...(values[fieldTypes.CONSULT_ID].value ? ({
      triggerObjectId: parseInt(values[fieldTypes.CONSULT_ID].value),
      triggerObjectType: "Consultation",
    }) : ({
      triggerObjectId: parseInt(values[fieldTypes.MEMBER].value.id),
      triggerObjectType: "Member",
    })),
  };
};

export const mapTaskToValues = (task, currentUser) => {
  const {
    name,
    typeCd,
    category,
    status,
    priority,
    assignees: [assignee],
    dueDate,
    consultation,
    member,
    taskDesc,
  } = task;

  const convertedDate = (dueDate === null) ? null : moment.tz(dueDate, SERVER_DATE_FORMAT, window.APP_TIMEZONE).utcOffset(moment().utcOffset(), true).toDate();

  return {
    ...defaultTaskFormValues,

    [fieldTypes.TASK_TYPE]: {
      value: typeCd,
      label: translate(null, "care_team_tasks.types", typeCd.replace("TASKTYPE_", "")),
    },
    [fieldTypes.TASK_NAME]: typeCd === "TASKTYPE_OTHER" ? name : "",
    [fieldTypes.URGENT]: priority === priorityCodes.URGENT,
    [fieldTypes.CATEGORY]: {
      value: category,
      label: translate(null, "care_team_tasks.categories", category.replace("TASKCATEGORY_", "")),
    },

    ...(assignee && {
      [fieldTypes.ASSIGNEE]: {
        value: parseInt(assignee.id),
        label: parseInt(assignee.id) === currentUser.id
          ? `${translate(null, "care_team_tasks.form.fields.assignee", "me")} (${currentUser.name})`
          : assignee.name,
      },
    }),

    [fieldTypes.STATUS]: {
      value: status,
      label: translate(null, "care_team_tasks.statuses", status.replace("TASKSTATUS_", "")),
    },
    [fieldTypes.DUE_DATE]: convertedDate,

    ...(consultation && {
      [fieldTypes.CONSULT_ID]: {
        value: consultation.id,
        label: consultation.id,
      },

      ...(consultation.provider && {
        [fieldTypes.PROVIDER]: translate(null, "care_team_tasks.form.fields.provider.option", "label", {
          id: consultation.provider.id,
          name: consultation.provider.name,
        }),
      }),
    }),

    [fieldTypes.NOT_CONSULT_RELATED]: !consultation,

    ...(member && {
      [fieldTypes.MEMBER]: {
        value: member,
        label: translate(null, "care_team_tasks.form.fields.member.option", "label", {
          id: member.id,
          name: member.name,
        }),
      },
      [fieldTypes.GROUP]: member.group.name,
    }),

    [fieldTypes.CHECKLIST]: taskDesc,
  };
};
